import { createStyles, rem } from "@mantine/core"

interface AddTextItemsToListInputInterface {
    isInputFocus: boolean
}

export const useStyles = createStyles((theme, { isInputFocus }: AddTextItemsToListInputInterface) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: rem(8),
        width: "100%",
    },
    label: {
        fontSize: rem(14),
        fontWeight: 500,
        lineHeight: "normal",
        fontStyle: "normal",
    },
    input: {
        display: "flex",
        width: "100%",
        "& .mantine-TextInput-input": {
            borderRadius: "4px 0px 0px 4px",
            "&:focus": {
                outline: "initial",
                boxShadow: "initial",
            },
        },
        ".mantine-TextInput-root": {
            width: "100%",
        },

        borderRadius: "4px",
        outline: isInputFocus && "1px solid #7259EF",
        boxShadow: isInputFocus && "0px 0px 0px 2px rgba(114, 89, 239, 0.48)",
    },
    button: {
        borderRadius: "0px 4px 4px 0px",
        color: "white",
        width: rem(40),
        height: rem(40),
        display: "flex",
        padding: rem(4),
        justifyContent: "center",
        alignItems: "center",

        "&.mantine-Button-root": {
            height: rem(40),
        },
    },
}))
